import { useRPCContext } from "../../../../../contexts/RPCContext.js";
import { useLayoutEffect, useState } from "react";
import { StatusDot, Tooltip } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/AppWrapper2/components/AppNav/components/OnlineIndicator.tsx
function OnlineIndicator() {
	const { rpcClient } = useRPCContext();
	const [connected, setConnected] = useState(() => rpcClient.getWebSocketConnected());
	useLayoutEffect(() => {
		return rpcClient.registerWebSocketConnectionStatusChangeListener((connected) => setConnected(connected));
	}, [rpcClient]);
	return /* @__PURE__ */ jsx(Tooltip, {
		className: "inline-flex items-center",
		tooltip: connected ? "Connected to THERMS" : "No connection to THERMS",
		children: /* @__PURE__ */ jsx(StatusDot, {
			ariaLabel: connected ? "Connected to THERMS" : "No connection to THERMS",
			className: connected ? "app-nav-live-dot" : void 0,
			size: "sm",
			variant: connected ? "positive" : "critical"
		})
	});
}
export { OnlineIndicator };

//# sourceMappingURL=OnlineIndicator.js.map